import { APP_INITIALIZE } from "./const";

function action(urlSearch) {
  return {
    type: APP_INITIALIZE,
    urlSearch,
  };
}

export default action;
